import './SquareBadge.scss';

export function SquareBadge(props) {
    return <div className={(props.className ?? '') + " SquareBadge"} style={props.style}>
        {props.children}
    </div>
}